import React from "react";
import { Button, Modal, Table } from "antd";
// import { Button, Modal, Table } from "antd";
import styles from "./index.module.scss";

interface Props {
  visible: boolean;
  onClose: () => void;
  sparePartDetails: any;
}

const SparePartDetailsModal: React.FC<Props> = ({
  visible,
  onClose,
  sparePartDetails,
}) => {
  if (!sparePartDetails) return null;

    const columns = [
    {
      title: "Spare Part Description",
      dataIndex: "itemDescription",
      key: "itemDescription",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "Product Description",
      dataIndex: "productDescription",
      key: "productDescription",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Service Center Ticket Number",
      dataIndex: "serviceCenterTicket",
      key: "serviceCenterTicket",
    },
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key: "serialNumber",
    },
    {
      title: "Comment",
      dataIndex: "registerComments",
      key: "registerComments",
    },
  ];

  // Calculate equal width as a percentage string
 

  // Add that `width` to each column definition
 
  const data = [sparePartDetails];

  console.log(sparePartDetails);

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1100}
      centered
      closable
      className={styles["spare-part-modal"]}
    >
      <div className={styles["spare-part-modal__title"]}>
        Spare Part Details
        <span className={styles["spare-part-modal__title-meta"]}>
          Item: {sparePartDetails.sparePartItem} | Service Center:{" "}
          {sparePartDetails.serviceCenter} | Sales Order:{" "}
          {sparePartDetails.salesOrderNumber}
        </span>
      </div>

      <Table
        dataSource={data}
        columns={columns}
        pagination={false}
        className={styles["spare-part-modal__table"]}
        style={{ width: "100%" }}
      />

      <div className={styles["spare-part-modal__footer"]}>
        <Button
          size="large"
          className="cancel-button"
          onClick={onClose}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default SparePartDetailsModal;
